import CircularProgressWithLabel from './CircularProgressWithLabel';

export default CircularProgressWithLabel;
